import React from 'react';
import { Typography } from '@mui/material';
import { BillingSwitchWrapper } from './style';
import { colors } from 'crono-fe-common/theme';
import { Options, Plan } from 'pages/signup/types';
import CronoSwitch from 'crono-fe-common/components/CronoSwitch';
import { BillingPlan } from '../../../model';
import { mapBillingPlanToText } from 'utils/businessLogic';

type BadgePlacement = 'top' | 'inside';

interface IProps {
  selectedPlan: Plan;
  options: Options[];
  billingPlan: BillingPlan;
  setBillingPlan: React.Dispatch<React.SetStateAction<BillingPlan>>;
  badgePlacement?: BadgePlacement;
}

const BillingSwitch = ({
  selectedPlan,
  options,
  billingPlan,
  setBillingPlan,
  badgePlacement = 'inside',
}: IProps) => {
  const otherBillingPlanOption: BillingPlan = 'quarterly'; // business decision. Can be set also to monthly if needed.

  //TODO: fix parameters passed to BillingSwitch (at least selectedPlan is not correct)
  // const calculateSavePercentage = (options: Options[], selectedPlan: Plan) => {
  //   const plan = options.find(
  //     (p) => p.subscriptionType === mapPlanToSubscriptionType(selectedPlan),
  //   );
  //   if (!plan) return 0;
  //
  //   const priceWithYearlyPaymentCycle = plan.prices.filter(
  //     (price) => price.paymentCycle === 'yearly',
  //   )[0];
  //   const priceWithMonthlyPaymentCycle = plan.prices.filter(
  //     (price) => price.paymentCycle === 'monthly',
  //   )[0];
  //
  //   return (
  //     100 -
  //     (priceWithYearlyPaymentCycle?.monthlyTotalCycle * 100) /
  //       priceWithMonthlyPaymentCycle?.monthlyTotalCycle
  //   ).toFixed(0);
  // };
  // const badgeJSX = useMemo(() => {
  //   return <></>;
  // const savePercent = calculateSavePercentage(options, selectedPlan);
  // return selectedPlan !== Plan.FREE_TRIAL ? (
  //   <span
  //     className={`badge discount ${badgePlacement === 'top' ? 'badge-top' : ''}`}
  //     style={{ flexShrink: 0 }}
  //   >
  //     Save {savePercent}% <IconArrowSTopRight />
  //   </span>
  // ) : (
  //   <></>
  // );
  // }, [selectedPlan, options, badgePlacement]);

  return (
    <BillingSwitchWrapper>
      {/*{badgePlacement === 'top' ? badgeJSX : null}*/}
      <div className={'billing-switch'}>
        <Typography
          fontSize={'14px'}
          color={billingPlan === 'yearly' ? colors.black : colors.grey11}
        >
          Pay {mapBillingPlanToText('yearly')}
        </Typography>
        {/*{badgePlacement === 'inside' ? badgeJSX : null}*/}

        <CronoSwitch
          sameSwitchColor={true}
          onChange={() => {
            setBillingPlan((prev) => {
              return prev === otherBillingPlanOption
                ? 'yearly'
                : otherBillingPlanOption;
            });
          }}
          checked={billingPlan === otherBillingPlanOption}
        />

        <Typography
          fontSize={'14px'}
          color={
            billingPlan === otherBillingPlanOption
              ? colors.black
              : colors.grey11
          }
        >
          Pay {mapBillingPlanToText(otherBillingPlanOption)}
        </Typography>
      </div>
    </BillingSwitchWrapper>
  );
};

export default BillingSwitch;
